<template>
    <div class="home-bottom-nav">
        <van-tabbar v-model="active">
            <van-tabbar-item icon="column"><router-link to="/bookshelf">书架</router-link></van-tabbar-item>
            <van-tabbar-item icon="bag"><router-link to="/">书城</router-link></van-tabbar-item>
            <van-tabbar-item icon="bar-chart-o"><router-link to="/rankinglist">排行</router-link></van-tabbar-item>
            <van-tabbar-item icon="underway" dot><router-link to="/Searching">搜索</router-link></van-tabbar-item>
            <van-tabbar-item icon="manager" dot><router-link to="/mycenter">我的</router-link></van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
export default {
    data() {
        return {
            active: 1
        };
    }
};
</script>

<style lang="less">
.home-bottom-nav {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1;
    .van-tabbar {
        .van-tabbar-item {
            &--active {
                color: rgb(184, 51, 32);
            }
        }
    }
}
</style>
